import { inject, Injectable, InjectionToken, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const sessionStorageToken = new InjectionToken<Storage>(
  'SessionStorageService',
  {
    factory() {
      return isPlatformBrowser(inject(PLATFORM_ID))
        ? window.sessionStorage
        : null;
    },
  },
);

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private storage = inject(sessionStorageToken);

  get(key: string): string | null {
    return this.storage.getItem(key);
  }

  set(key: string, value: any) {
    this.storage.setItem(key, JSON.stringify(value));
  }

  remove(key: string) {
    this.storage.removeItem(key);
  }
}
